<div class="sidebar-wrapper">
  <ng-content></ng-content>
</div>
